<nav class="av-list-container" aria-label="Side navigation">
    <ul class="av-list">
        @for (item of items(); track item.id) {
        <li class="av-list-item">
            <button type="button" class="av-list-link" [class.active]="selectedItemId() === item.id"
                (click)="selectItem(item)">
                <span class="item-label">{{ item.label }}</span>
            </button>
        </li>
        }
    </ul>
</nav>